import { AccommodationTypeEnum } from '../generated/graphql';
import accommodationTypes from '../constants/accommodationTypes';

export const getAccommodationTypeTranslation = (typeEnum?: AccommodationTypeEnum) =>
    accommodationTypes.find(type => type.value === typeEnum)?.label;
